// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_Ghc","cls2":"ImpactStatTile-cls2_SDR ImpactStatTile-cls1_Ghc","impact-stat-count-shimmer":"ImpactStatTile-impact-stat-count-shimmer_6qT"};